import React from 'react';

export const useMemoizedArray = <T, R = T extends undefined ? undefined : Array<T>>(
  arr: Array<T> | undefined,
): R => {
  const ref = React.useRef(arr);

  // Update ref during render, not in useEffect to prevent infinite loops
  if (
    !arr ||
    !ref.current ||
    arr.length !== ref.current.length ||
    arr.some((item, index) => item !== ref.current![index])
  ) {
    ref.current = arr;
  }

  return ref.current as R;
};
